'use client';

import { css } from '@repo/pandacss/styled-system/css';
import { STATES_MAP } from '@repo/supergraph/marketplace/constants';
import { useGeo } from '../GeoProvider/hook';

export function PaidRoundupEyebrow({ isGeoTargeted }: { isGeoTargeted?: boolean }) {
  const { isReady, regionCode } = useGeo();

  let disclosureText = 'ADVERTISEMENT: PRODUCTS FROM OUR PARTNERS';
  if (isGeoTargeted && isReady && regionCode) {
    const stateName = STATES_MAP[regionCode];
    if (stateName) {
      disclosureText += ` - ${stateName.toUpperCase()}`;
    }
  }

  return (
    <p
      className={css({
        textStyle: 'textBold',
        fontSize: 'sm',
        fontWeight: 'semibold',
        color: 'neutral.darker',
        marginTop: '0',
        marginRight: '0',
        marginBottom: '0',
        marginLeft: '0',
      })}
    >
      {disclosureText}
    </p>
  );
}
